export default "__VITE_ASSET__1f6a6a94__"